import { OptionDto } from "@/dtos";

const identificationTypes = [
    { value: 1, label: 'Cédula' },
    { value: 2, label: 'RUC' },
    { value: 3, label: 'Pasaporte' }
] as OptionDto[];

export const getIdentificationOptions = (): OptionDto[] => {
    return identificationTypes;
}

export const getIdentification = (value: number): OptionDto => {
    return identificationTypes.find((x) => x.value == value) ?? identificationTypes[0];
}
